import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpHeader from '../Member/shared/httpheader';
import enData from './en';
import keenanData from './keenan';

const resources = {
  en: {
    translation:
      HttpHeader.getCNAME().includes('keenan') ||
      HttpHeader.getCNAME().includes('tpabenefits')
        ? keenanData
        : enData,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
  keySeparator: '.',
});

export default i18next;
